import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

/** Shown for an unknown in-app URL instead of an empty page. */
const PageNotFound: React.FC = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
            <Paper sx={{ p: 4, maxWidth: 480, textAlign: 'center' }} data-testid="page-not-found" data-help-page="common.notFound.page">
                <SearchOffIcon color="disabled" sx={{ fontSize: 48 }} />
                <Typography variant="h6" gutterBottom>Page not found</Typography>
                <Typography color="text.secondary" sx={{ mb: 2 }}>
                    This address doesn't match any page. Use the menu, or go back to the home page.
                </Typography>
                <Button variant="contained" onClick={() => navigate('/')} data-help="common.notFound.home">Go to home</Button>
            </Paper>
        </Box>
    );
};

export default PageNotFound;
